import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import WeeklyStats from "./admin/weeklyStats"; // імпорт компонента
import UserDashboard from "../pages/user/userDashboard";
import VehicleUsageRejectedAlert from "../components/VehicleUsageRejectedAlert";
import { useTranslation } from 'react-i18next';



const Dashboard = () => {
  const [role, setRole] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const userRole = localStorage.getItem("role"); // Отримуємо роль із LocalStorage
    if (!userRole) {
      navigate("/login"); // Якщо немає ролі, перенаправляємо на логін
    } else {
      setRole(userRole);
    }
  }, [navigate]);

  return (
    <div className="container mt-5">
      <h2>{t("dashboard")}</h2>

      {/* Блок для ролі NEW */}
      {role === "new" && (
        <div className="alert alert-warning">
          <h4>{t("hello")} {t("new").toLocaleLowerCase()} {t("user").toLocaleLowerCase()}!</h4>
          <p>{t("notAproved")}</p>
          
        </div>
      )}

      {/* Блок для ролі USER */}
      {role === "user" && (
       
        <UserDashboard />
      )}

      {/* Блок для ролі ADMIN */}
      {role === "admin" && (
        <>
          <WeeklyStats />
          <VehicleUsageRejectedAlert />
        </>
      )}
    </div>
  );
};

export default Dashboard;
